<div class="header-container">
  <h1 class="h1Header">Reglas de Costos por Hora - Punto Fijo</h1>
</div>

<div class="pricing-rules-container">

  <div class="cards-container" *ngIf="pricingRules.length > 0; else noRules">
    <div *ngFor="let rule of pricingRules" class="card">
      <div class="card-header">
        <div class="card-icon">{{ getIcon(rule.category) }}</div>
        <span class="status-badge" [ngClass]="{'active': rule.isActive, 'inactive': !rule.isActive}">
          {{ rule.isActive ? 'ACTIVA' : 'INACTIVA' }}
        </span>
      </div>
      <div class="card-content">
        <h3 class="card-title">{{ getCategoryDescription(rule.category) }}</h3>
        <p class="card-value">{{ formatValue(rule) }}</p>
        <p class="card-vigencia" *ngIf="rule.vigenciaDesde">Vigencia desde: {{ rule.vigenciaDesde | date:'dd/MM/yyyy' }}</p>
      </div>
      <button type="button" class="edit-btn" (click)="onEdit(rule)">Editar</button>
    </div>
  </div>

  <ng-template #noRules>
    <div class="no-rules-message">
      <p>No se encontraron reglas de costos por hora.</p>
    </div>
  </ng-template>

  <div class="modal-overlay" [ngClass]="{'active': isEditModalOpen}">
    <div class="modal-content">
      <div class="modal-header">
        <h3>Editar Regla de Costo</h3>
        <button type="button" class="close-btn" (click)="closeEditModal()">&times;</button>
      </div>
      
      <form [formGroup]="editForm" (ngSubmit)="saveRule()" class="edit-form" novalidate>
        <div class="form-group">
          <label>Categoría</label>
          <p class="form-control-static" *ngIf="currentRule">{{ getCategoryDescription(currentRule.category) }}</p>
        </div>

        <div class="form-group">
          <label>Tipo de Regla</label>
          <p class="form-control-static" *ngIf="currentRule">Monto Fijo</p>
        </div>
        
        <div class="form-group">
          <label for="value">Valor ($)</label>
          <input type="number" id="value" formControlName="value" class="form-control" min="0" step="0.01">
          <div *ngIf="editForm.get('value')?.invalid && editForm.get('value')?.touched" class="error-message">
            El valor es requerido y debe ser un número positivo.
          </div>
        </div>

        <div class="form-group">
          <label for="vigenciaDesde">Vigencia desde (opcional)</label>
          <input type="date" id="vigenciaDesde" formControlName="vigenciaDesde" class="form-control">
          <div class="hint-message">Si se indica, la regla no podrá usarse para turnos anteriores a esa fecha.</div>
        </div>
        
        <div class="form-actions">
          <button type="button" class="cancel-btn" (click)="closeEditModal()">Cancelar</button>
          <button type="submit" class="save-btn" [disabled]="editForm.invalid">Guardar Cambios</button>
        </div>
      </form>
    </div>
  </div>
</div>
